import React, {useState, useEffect} from "react";
import {connect} from "react-redux"
import {useForm} from 'react-hook-form';

import toast, { Toaster } from 'react-hot-toast';
import {Spinner} from "react-bootstrap";
import UserPrefsService from "../../../services/UserPrefsService";

import useDebounce from "../../../components/utilities/useDebounce";
import ProfileLocalizeMe from "./ProfileLocalizeMe";
import ProfilForm from "./ProfilForm";


const UserPrefs = (props)=>{

    //const [userPrefs, setUserPrefs] = useState({})
    const [asData, setAsData] = useState(false)
    const [entity, setEntity] = useState([])
    const [user, setUser] = useState([])
    //const userPrefsDebounced = useDebounce(userPrefs, 500);
    //let userPrefsService = new UserPrefsService();
    const [isLoading, setIsLoading] = useState(false)
    const {register, handleSubmit, errors, reset } = useForm({});


    const [formAnnexes, setFormAnnexes] = useState(
        {
            delivrance_txt: null,
            intro_txt: null,
            a1_txt: null,
            a2_txt: null,
            a5_ta: null,
            a5_td: null,
            a5_rap: null,
            a6_txt1: null,
            a6_txt2: null
        }
    );

    useEffect(()=>{
        setFormAnnexes(formAnnexes)
    }, [formAnnexes])


    useEffect(()=>{

    }, [])
    /*

    useEffect(()=>{
        (userPrefs)?setAsData(true):false;
    }, [userPrefs])

    useEffect(()=>{
        (props.userPrefs)?setUserPrefs(props.userPrefs):null;
    }, [props.userPrefs])

    useEffect(()=>{
        (userPrefs && Object.keys(userPrefs).length > 0 )?handleUpdatePrefs():null;
    }, [userPrefsDebounced])


    const handleUpdatePrefs=()=>{
            const args = {
                userPrefs: userPrefs
            }
            props.updateUserInfo({prefs:args.userPrefs});
    }

    const handleToggleCheck = (e, thema)=> {
        e.persist();
        setUserPrefs( (prevState) => ({
            ...prevState,
            [thema] : { ...prevState[thema],
                [e.target.name]: {...prevState[thema][e.target.name],
                    value: e.target.checked}
            }
        }))
    }

    const handleInputChange = (e, thema)=>{
        e.persist();
        setUserPrefs( (prevState) => ({
            ...prevState,
            [thema] : { ...prevState[thema],
                [e.target.name]: {...prevState[thema][e.target.name],
                    value: e.target.value}
            }
        }))
    }

    const renderGroupItems=(e, sectionName,  indexSection)=>{
        return(
                <div key={sectionName}>
                    <h5 className={"font-weight-bold "}>{sectionName}</h5>
                    <div className={"d-flex flex-column justify-content-between"}>
                    {
                        (Object.keys(e).map((i, index)=>{
                            return(
                                renderCheckboxItem(e[i], i, sectionName )
                            )
                        }))
                    }
                    </div>
                </div>
        )
    }
    /*
    const renderCheckboxItem= (e, sectionName, thema)=>{
        switch (e.type){
            case "bool":
                return(
                    <div key={sectionName} className="custom-control custom-switch custom-control-inline mb-4 d-flex justify-content-between">
                        <span style={{'fontWeight': '500'}} >{e.label}</span>
                        <input
                            type="checkbox"
                            className="custom-control-input ue-big-switch"
                            id={sectionName}
                            name={sectionName}
                            onChange={(a)=>{handleToggleCheck(a, thema)}}
                            checked={e.value}
                        />
                        <label className="custom-control-label" htmlFor={sectionName}> </label>
                    </div>
                )
            case "text":
                return(
                    <div key={sectionName} className="d-flex justify-content-between">
                        <span style={{'fontWeight': '500'}}>{e.label}</span>
                        <input type="text"
                               disabled
                               className="form-control"
                               id={sectionName} name={sectionName}
                               onChange={(e)=>handleInputChange(e, thema)}
                               value={(props.uiTheme)?props.uiTheme:'light'}/>
                        <label className="control-label" htmlFor={sectionName}> </label>
                    </div>
                )
            default:
                break;
        }
    }

     */

    return (
        <div className={"text-dark bg-white  w-100 h-100 "}>
            <div className={"row"}>
                <div className={"col-12 col-md-6"}>
                    <div className={"d-flex flex-column justify-content-start align-items-start w-100"}>
                        <h6 className={"my-3 font-weight-bold"}>Certificat durbanisme</h6>
                        {(isLoading) ?
                            <div className="row vh-100">
                                <div className="col-12 justify-content-center align-items-center">
                                    <div className="text-center my-2 ">
                                        <Spinner animation="border" size={'sm'}/>
                                    </div>
                                </div>
                            </div>
                            : /*(asData &&userPrefs && Object.keys(userPrefs).length > 0) ?
                                    Object.keys(userPrefs).map((item, index) => {
                                        return (["formulaire", "interface", "notifications"].includes(item) ? renderGroupItems(userPrefs[item], item, index) : null);

                                    })
                                    : null
                                    */
                            <div className="tab-content py-2" id="forms">
                                <ProfilForm
                                    annexes={formAnnexes}
                                    refRegister={register}
                                    errors={errors}
                                    reset={reset}
                                    entityLocal={entity}
                                    setEntityLocal={setEntity}
                                />
                            </div>

                        }
                    </div>
                </div>
                <div className={"col-12 col-md-6"}>
                    <ProfileLocalizeMe />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        userId: state.MeReducer.id,
        username : state.MeReducer.username,
        role : state.MeReducer.role,
        uiTheme: state.AppReducer.ui_theme,
        userPrefs: state.MeReducer?.prefs,
        structureInfo: state.SubscribtionReducer.structureInfo,
        entity: state.MeReducer.entity,
    }
}

const mapDispatchTProps = dispatch => {
    return {
        updateUserInfo: (e) => dispatch( {type: 'UPDATE_USER_STATUS', data:e}),
    }
}


export default connect(mapStateToProps, mapDispatchTProps)(UserPrefs);





